import { createElement } from 'react';
import { Slider, ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import enUS from 'antd/es/locale/en_US';
import 'antd/dist/antd.variable.min.css';
import '../../variables.scss';
const SliderOuter = (props) => {
    ConfigProvider.config({
        theme: {
            primaryColor: '#f16622',
        },
    });
    const { range } = props;
    let { defaultValue } = props;
    if (range) {
        defaultValue = Array.isArray(defaultValue) ? defaultValue : [0, defaultValue];
    }
    else {
        defaultValue = Array.isArray(defaultValue) ? defaultValue[1] || defaultValue[0] : defaultValue;
    }
    return (createElement(ConfigProvider, { locale: localStorage.getItem('umi_locale') !== 'en-US' ? zhCN : enUS },
        createElement(Slider, { ...props, defaultValue: defaultValue })));
};
export default SliderOuter;
